function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  fill: "none"
}, React.createElement("path", {
  fill: "#232323",
  d: "M21.6 18.6c0 1.657-1.343 3-3 3H3c-1.657 0-3-1.343-3-3V3c0-1.657 1.343-3 3-3h15.6c1.657 0 3 1.343 3 3v15.6z"
}), React.createElement("path", {
  fill: "#FFF",
  d: "M9.874 4.066c-3.036.33-5.478 2.772-5.808 5.742-.33 3.102 1.452 5.874 4.158 6.93.198.066.396-.066.396-.33v-1.056s-.264.066-.594.066c-.924 0-1.32-.792-1.386-1.254-.066-.264-.198-.462-.396-.66-.198-.066-.264-.066-.264-.132 0-.132.198-.132.264-.132.396 0 .726.462.858.66.33.528.726.66.924.66.264 0 .462-.066.594-.132.066-.462.264-.924.66-1.188-1.518-.33-2.64-1.188-2.64-2.64 0-.726.33-1.452.792-1.98-.066-.132-.132-.462-.132-.924 0-.264 0-.66.198-1.056 0 0 .924 0 1.848.858.33-.132.792-.198 1.254-.198.462 0 .924.066 1.32.198.858-.858 1.848-.858 1.848-.858.132.396.132.792.132 1.056 0 .528-.066.792-.132.924.462.528.792 1.188.792 1.98 0 1.452-1.122 2.31-2.64 2.64.396.33.66.924.66 1.518v1.716c0 .198.198.396.462.33 2.442-.99 4.158-3.366 4.158-6.138 0-3.96-3.366-7.062-7.326-6.6z"
}));

var SvgIconGithub = function SvgIconGithub(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgIconGithub, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-github.19d13fd1.svg";
export { ForwardRef as ReactComponent };